<div fxLayout='row'>
    <h2 mat-dialog-title fxFlex="1 0 auto" fxFlexAlign="start">Podium Browser Content License</h2>
    <button mat-icon-button mat-dialog-close><mat-icon aria-label="Close" fxFlex="1,0,20px" class="close-button" >close</mat-icon></button>
</div>
<mat-dialog-content>
    <div fxLayout='column'>
        <p fxFlex="1 0 auto">Below is your current Podium License Key.</p>

        <form [formGroup]="licenseForm" fxFlex="1 0 auto" fxLayout='column'>

            <mat-form-field fxFlex="1 0 auto" class="license field-row">
                <input matInput readonly="readonly" formControlName="license">

                <mat-error *ngIf="licenseForm.get('license').errors">{{ data.message }}</mat-error>
            </mat-form-field>

        </form>

    </div>
</mat-dialog-content>



// WEBPACK FOOTER //
// ./src/app/home-page/license-modal/license-modal.component.html